import { render } from "./results-card.vue?vue&type=template&id=ac20199a"
import script from "./results-card.vue?vue&type=script&lang=js"
export * from "./results-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__